import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, FormControl, InputLabel, Select, MenuItem, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { apiRequest } from '../../../utils/fetch';
import { AdSpacePhotoCommentInterface, GenericResponseInterface } from '../../../interfaces/interfaces';

const initialComment: Partial<AdSpacePhotoCommentInterface> = {
  adSpacePhotoId: 0,
  comment: '',
  active: true,
};

const AdSpacePhotoCommentsAdminAddPhotoCommentPage: React.FC = () => {
  const [comment, setComment] = useState<Partial<AdSpacePhotoCommentInterface>>(initialComment);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleChange = (field: keyof AdSpacePhotoCommentInterface, value: any) => {
    setComment(a => ({ ...a, [field]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const result = await apiRequest<GenericResponseInterface<AdSpacePhotoCommentInterface>>('/adSpacePhotoComments/insert', 'POST', comment);
      if (result.status) {
        setSuccess(result.message || 'Comment created successfully!');
        setDialogOpen(true);
        setComment(initialComment);
      } else {
        setError(result.message || 'Failed to create comment');
        setDialogOpen(true);
      }
    } catch (err: any) {
      setError(err.message || 'Failed to create comment');
      setDialogOpen(true);
    }
  };

  return (
    <Paper sx={{ p: 3, maxWidth: 500, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add New Ad Space Photo Comment</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Ad Space Photo ID"
          type="number"
          value={comment.adSpacePhotoId ?? ''}
          onChange={e => handleChange('adSpacePhotoId', Number(e.target.value))}
          fullWidth
          margin="dense"
          required
        />
        <TextField
          label="Comment"
          value={comment.comment ?? ''}
          onChange={e => handleChange('comment', e.target.value)}
          fullWidth
          margin="dense"
          required
        />
        <FormControl fullWidth margin="dense">
          <InputLabel id="active-label">Active</InputLabel>
          <Select
            labelId="active-label"
            value={comment.active !== undefined ? (comment.active ? 'yes' : 'no') : 'yes'}
            label="Active"
            onChange={e => handleChange('active', e.target.value === 'yes')}
          >
            <MenuItem value="yes">Yes</MenuItem>
            <MenuItem value="no">No</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="submit" variant="contained" color="primary">
            Create Comment
          </Button>
        </Box>
      </form>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>{success ? 'Success' : 'Error'}</DialogTitle>
        <DialogContent>
          <Typography>{success || error}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default AdSpacePhotoCommentsAdminAddPhotoCommentPage;